import React from 'react';
import { DropdownIndicatorProps } from 'react-select';
import { SelectOption } from '../../..';
import classNames from 'classnames';
import { DropdownIcon } from '../../../../DropdownIcon';

export function TransparentDropdownIndicator(
  props: DropdownIndicatorProps<SelectOption, false>,
) {
  return (
    <DropdownIcon
      menuIsOpen={props.selectProps.menuIsOpen}
      classNames={classNames('fs-2')}
      isDisabled={props.isDisabled}
    />
  );
}
